import { createSlice } from '@reduxjs/toolkit';


 const initialState ={
    loanAmmount:"1000000",
   timePeriod:"3",
   intrestRate:"12",
   edErrors: null,
   totalAmount: 0,

 }

 const bussinessSlice = createSlice({
    name:'bussinessCalculator',
    initialState,
    reducers:{

        setLoanAmmount: (state, action) => {
            state.loanAmmount = action.payload;
          },
          setTimePeriod: (state, action) => {
            state.timePeriod = action.payload;
          },
          setIntrestRate: (state, action) => {
            state.intrestRate = action.payload;
          },
          setEdErrors: (state, action) => {
            state.edErrors = action.payload;
          },
          setBussinessEmi: (state, action) => { 
            state.bussinessEmi = action.payload;
          },
          setTotalAmount: (state, action) => {
            state.totalAmount = action.payload;
          },
          setRemoveFields: (state) => {
            state.loanAmmount = "1000000";
            state.timePeriod = "3";
            state.intrestRate = "12";
            state.edErrors = null;
            state.totalAmount = 0;
          },
           resetBusinessData: (state) => {
                return initialState;
              },
    }
 });

 export const { setActiveCalculater} = bussinessSlice.actions;
 export const {
    setLoanAmmount, setTimePeriod, setIntrestRate, setEdErrors, setBussinessEmi,setRemoveFields,resetBusinessData,setTotalAmount
 }= bussinessSlice.actions;
 export default bussinessSlice.reducer;
